import React from 'react';

import "./PriceTag.scss";
import { Months } from '../../../elements/Months/Months';
import { Czk } from '../../../elements/Czk/Czk';

export const PriceTag = (props)=>{
    const { monthCount, pricePerMonth } = props;

    return (
        <div className="PriceTag">
            <Months count={monthCount}/>
            <span> za </span>
            <Czk value={monthCount*pricePerMonth}/>
        </div>
    );
}
